package com.yogaaicoach.pages.workout.workout.ui.model

data class ExerciseVideoUrls(
    val introUrl: String?,
    val loopUrl: String,
    val outroUrl: String?
) {
    fun initialUrl(): String = introUrl ?: loopUrl
}
